<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                <span *ngIf="!UserId">Adding User</span>
                <span *ngIf="UserId">Update User</span>
            </h1>
        </div>
        <div class="card">
            <form [formGroup]="userForm" (submit)="createUser()">

                <div class="card-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-6 col-lg-6 right-border">
                                <div class="form-group">
                                    <label class="form-label">Name *</label>
                                    <input [ngClass]="{'readOnly':myrole!='1'}" type="text" formControlName="name" class="form-control" />
                                    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                        <div *ngIf="f.name.errors.required">Name is required</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="form-label">Employee Id *</label>
                                    <input [ngClass]="{'readOnly':myrole!='1'}" type="text" formControlName="employee_id" class="form-control" />
                                    <div *ngIf="submitted && f.employee_id.errors" class="invalid-feedback">
                                        <div *ngIf="f.employee_id.errors.required">Employee is required</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="form-label">Email *</label>
                                    <input [ngClass]="{'readOnly':myrole!='1'}" type="text" formControlName="email" class="form-control" />
                                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                        <div *ngIf="f.email.errors.required">Email is required</div>
                                        <div *ngIf="!f.email.valid && f.email.value">Email format is Invalid</div>
                                    </div>
                                </div>
                                <div class="form-group" *ngIf="myrole=='1'">
                                    <label class="form-label">Role *</label>
                                    <mat-select  [ngClass]="{'readOnly':myrole!='1'}" placeholder="Role" formControlName="role">
                                        <mat-option [value]="userrole.id" *ngFor="let userrole of userRoles" >{{userrole.role_name}}</mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.role.errors" class="invalid-feedback">
                                        <div *ngIf="f.role.errors.required">Role is required</div>
                                    </div>
                                </div>
                                <div class="form-group" *ngIf="userForm.controls['role'].value == 5">
                                    <div class="mt-6">
                                        <label class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" formControlName="all_access">
                                            <span class="custom-control-label">All Access</span>
                                          </label>
                                    </div>
                                </div>
                                <div class="form-group" *ngIf="userForm.controls['role'].value == 3 || userForm.controls['role'].value == 4 || userForm.controls['role'].value == 10 || userForm.controls['role'].value == 14">
                                    <div class="mt-6">
                                        <label class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" formControlName="is_cm_access">
                                            <span class="custom-control-label">CM Access</span>
                                          </label>
                                    </div>
                                </div>
                                <div class="form-group" *ngIf="userForm.controls['role'].value == 3">
                                    <div class="mt-6">
                                        <label class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" formControlName="is_presales_access">
                                            <span class="custom-control-label">Presales Access</span>
                                          </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label class="form-label">Mobile *</label>
                                    <input [ngClass]="{'readOnly':myrole!='1'}" type="text" formControlName="mobile" class="form-control" />
                                    <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                                        <div *ngIf="f.mobile.errors.required">Mobile is required</div>
                                        <div *ngIf="!f.mobile.valid && f.mobile.value">Invalid Mobile number format</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="form-label">Circle *</label>
                                    <mat-select  placeholder="Circle" formControlName="circle_id" (click)="setSearchValue()" multiple [sortComparator]='sortFunc'>
                                        <input class="mySearchInput"
                                        #circleSearch focused="'true'" type="text"
                                        (keyup)="searchOnSelect($event.target.value, 'circle')"
                                        (keydown)="$event.stopPropagation()" autocomplete="off"
                                        placeholder="Search"
                                        id="circleSearch">
                                        <mat-option [value]="cir.id" *ngFor="let cir of circles" >{{cir.name}}</mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.circle_id.errors" class="invalid-feedback">
                                        <div *ngIf="f.circle_id.errors.required">Circle is required</div>
                                    </div>
                                </div>
                                <div class="form-group" *ngIf="userForm.controls['role'].value == 2 || userForm.controls['role'].value == 3">
                                    <label class="form-label">Select Catergory</label>
                                    <mat-select [ngClass]="{'readOnly':myrole!='1'}" placeholder="Select Catergory" formControlName="treatment_catergory_access" multiple>
                                        <mat-option [value]="cat.id" *ngFor="let cat of treatCategory" >{{cat.name}}</mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                        <div *ngIf="f.status.errors.required">Status is required</div>
                                    </div>
                                </div>

                                <div class="form-group" *ngIf="(myrole=='1' && userForm.controls['role'].value == 2)">
                                    <label class="form-label">TL's</label>
                                    <mat-select placeholder="TL's" formControlName="tl_id">
                                        <input class="mySearchInput"
                                        #tlSearch focused="'true'" type="text"
                                        (keyup)="searchOnSelect($event.target.value, 'tls')"
                                        (keydown)="$event.stopPropagation()" autocomplete="off"
                                        placeholder="Search"
                                        id="tlSearch">
                                        <mat-option [value]="tlids.id" *ngFor="let tlids of tls" >{{tlids.name}}</mat-option>
                                    </mat-select>
                                </div>

                                <div class="form-group" *ngIf="(myrole=='1' && (userForm.controls['role'].value == 2 || (userForm.controls['role'].value == 3 && userForm.controls['is_cm_access'].value != 1)))">
                                    <label class="form-label">CM's</label>
                                    <mat-select placeholder="CM's" formControlName="cm_id">
                                        <input class="mySearchInput"
                                        #cmSearch focused="'true'" type="text"
                                        (keyup)="searchOnSelect($event.target.value, 'cms')"
                                        (keydown)="$event.stopPropagation()" autocomplete="off"
                                        placeholder="Search"
                                        id="cmSearch">
                                        <mat-option [value]="cmids.id" *ngFor="let cmids of cms" >{{cmids.name}}</mat-option>
                                    </mat-select>
                                </div>



                            </div>
                            <div class="col-md-6 col-lg-6" *ngIf="myrole=='1'">

                                <div class="form-group">
                                    <label class="form-label">Password <span *ngIf="!UserId">*</span></label>
                                    <input autocomplete="new-password"  [type]="passwordhide ? 'password' : 'text'" formControlName="password" class="form-control input-password" />
                                    <mat-icon class="passwordicon" (click)="showPassword()">{{passwordhide ? 'visibility_off' : 'visibility'}}</mat-icon>
                                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                        <div *ngIf="f.password.errors.required">Password is required</div>
                                        <div *ngIf="!f.password.valid && f.password.value">Your password must be minimum 8 characters.</div>

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6" *ngIf="myrole=='1'">
                                <div class="form-group">
                                    <label class="form-label">Status *</label>
                                    <mat-select  placeholder="Status" formControlName="status">
                                        <mat-option [value]="1">Active</mat-option>
                                        <mat-option [value]="0">In-Active</mat-option>

                                    </mat-select>
                                    <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                        <div *ngIf="f.status.errors.required">Status is required</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i>
                         <span *ngIf="!UserId">Create User</span>
                        <span *ngIf="UserId">Update User</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
